import { useContext, useEffect } from "react";
import Game from "../store/Game";
import { SOCKET_EVENTS, SocketContext } from "../components/SocketProvider";
import useCurrentUserData from "./useCurrentUserData";

export default function useAllGameEvents() {
  const { socket } = useContext(SocketContext);
  const { getUserData } = useCurrentUserData();

  const onAllGameEventsReq = async (response) => {
    const user = getUserData();
    if (response.gameEvents && Array.isArray(response.gameEvents)) {
      const isUserMessage = response.gameEvents.some(
        (el) => el.userId === user.id
      );
      if (user && isUserMessage) {
        Game.setGameEventsData(
          response.gameEvents.filter((item) => item.userId === user.id),
          "socket"
        );
      }
    }
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.END_GAME_MESSAGE, onAllGameEventsReq);
    return () => {
      socket.current.off(SOCKET_EVENTS.END_GAME_MESSAGE, onAllGameEventsReq);
    };
  }, [socket]);
}
